import { ExaminerFunction } from '../../pages/Assessment/Assessment.types';

export interface ExaminersList {
  examiner: Examiner | null;
  function: ExaminerFunction;
  inferiors: Inferiors[];
  id: string;
  examinerFunctionId?: string;
  isQualified?: boolean;
  isActive?: boolean;
  isClosed?: boolean;
  isHighlightText?: boolean;
  examiningTeamId?: string;
}

export interface ExtendedExaminersList extends Omit<ExaminersList, 'inferiors'>, Record<string, unknown> {
  inferiors: ExtendedInferiors[];
  displayName: string;
  tooltipText: string;
  isCurrentUser: boolean;
  canUserSendMessageTo: boolean;
  blockadeTypeId: BlockadeTypeId | undefined;
}

export interface FlatExtendedExaminersList {
  [index: string]: ExtendedExaminersList;
}

export interface Examiner {
  displayName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  examinerPermission?: ExaminerPermission | null;
  id: string;
  examinerFunctionId?: string;
  isQualified?: boolean;
  examinerId?: string;
  userId?: string;
  isOnline: boolean;
}

export interface ExaminerPermission {
  examinerNumber: null | string;
  isBlocked: BlockadeTypeId;
  id: string;
}

export interface UserIds {
  userIds: string[];
}

export interface UserLogged {
  key: string;
  value: boolean;
}

export type Inferiors = ExaminersList;
export type ExtendedInferiors = ExtendedExaminersList;

export enum BlockadeTypeId {
  None,
  Automatic,
  Manual,
  Any,
}

export interface MenuItemsConditions {
  blockUnblockTeam: boolean;
  blockUnblockExaminer: boolean;
  blockUnblockPZE: boolean;
  unblockAllExaminers: boolean;
  sendMessages: boolean;
}
